/**
 * @generated SignedSource<<88709f1fd6dcc8feb03fc9bd5a2c4912>>
 * @relayHash 5d379598e5fdccd9bc50672ff4bfcf4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 355bf590e0e235619af23a698a8edd4d1cae75ce0022b643e6217569ff3c1d6c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NotificationsRefetchQuery$variables = {
  collabContextRoutingAri?: string | null;
};
export type NotificationsRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Notifications">;
};
export type NotificationsRefetchQuery = {
  response: NotificationsRefetchQuery$data;
  variables: NotificationsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collabContextRoutingAri"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "NotificationsRefetchQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "Notifications"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsRefetchQuery",
    "selections": [
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "collabContextRoutingAri",
                "variableName": "collabContextRoutingAri"
              }
            ],
            "kind": "ScalarField",
            "name": "unseenNotificationCount"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "355bf590e0e235619af23a698a8edd4d1cae75ce0022b643e6217569ff3c1d6c",
    "metadata": {},
    "name": "NotificationsRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "31af0dc011e585e154d3c49db2198487";

export default node;
